/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import { StatusLabel, Switch } from '@neo4j-ndl/react';
import { useState } from 'react';

import { ConditionalWrap } from '../ConditionalWrap';

const Component = () => {
  const [shouldWrap, setShouldWrap] = useState(false);

  return (
    <div className="n-flex n-flex-col n-gap-6">
      <Switch
        isChecked={shouldWrap}
        onChange={() => setShouldWrap(!shouldWrap)}
        label="shouldWrap"
      />
      <ConditionalWrap
        shouldWrap={shouldWrap}
        wrap={(children) => <StatusLabel>{children}</StatusLabel>}
      >
        Content
      </ConditionalWrap>
    </div>
  );
};

export default Component;
